import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions } from '@mui/material';
import { MetadataError } from '@ep/error-handling';
import { generateUuidV4 } from '../../../util/uuid';
import { log } from '../../../util/log';
import GhostButton from '../button/GhostButton';
import PrimaryButton from '../button/PrimaryButton';
import { BodyText, Subheading } from '../typography/PrimaryTypography';

const UnsavedChangesModal = ({
  open,
  unsaved_form_name,
  unsaved_title,
  save_loading,
  handleCloseConfirmModal,
  handleSaveChanges,
  handleProceed
}: {
  open: boolean;
  unsaved_title?: string | null;
  unsaved_form_name?: string | null;
  save_loading: boolean;
  handleProceed: () => void;
  handleSaveChanges: () => Promise<void>;
  handleCloseConfirmModal: () => void;
}) => {
  const handleProceedClick = async (save_changes: boolean) => {
    try {
      if (save_changes) {
        await handleSaveChanges();
      }
      handleProceed();
      handleCloseConfirmModal();
    } catch (err: unknown) {
      const tracking_id: string = generateUuidV4();
      log(
        'error',
        new MetadataError(
          err instanceof Error
            ? err.message
            : 'Error: DeleteConfirmModal failed on an unknown error while calling handleProceedClick.',
          null,
          tracking_id
        )
      );
    }
    return;
  };

  return (
    <Dialog open={open} onClose={handleCloseConfirmModal}>
      <Subheading
        weight="Bold"
        sx={{ m: 2 }}
      >{`${unsaved_title ?? 'Warning: Unsaved Changes'}`}</Subheading>
      <DialogContent>
        <BodyText
          id="warning-explainer"
          mb={1}
        >{`Do you want to save the changes you made to ${unsaved_form_name ?? 'your form'}?`}</BodyText>
        <BodyText>{`Your changes will be lost if you don’t save them.`}</BodyText>
        <DialogActions sx={{ mt: 2 }}>
          <GhostButton dark onClick={handleCloseConfirmModal}>
            {'Cancel'}
          </GhostButton>
          <PrimaryButton loading={save_loading} onClick={() => handleProceedClick(true)}>
            {'Save'}
          </PrimaryButton>
          <PrimaryButton palette_color="error" onClick={() => handleProceedClick(false)}>
            {"Don't Save"}
          </PrimaryButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default UnsavedChangesModal;
